<template>
  <v-btn
    color="primary"
    class="btn-subscription"
    dark
    :to="link"
  >
    {{ campaign_name }}
  </v-btn>
</template>

<script>
export default {
  props: ['link', 'campaign_name']
}
</script>
